import { Paper, Popper } from '@mui/material';
import { styled } from '@mui/material/styles';

const tooltipShadow =
    '0px 5px 6px -3px #00000033, 0px 9px 12px 1px #00000024,0px 3px 16px 2px #0000001F';

// Styled tooltip with our base styling
export const StyledTooltip = styled(Paper)({
    maxWidth: 684,
    padding: '16px 16px',
    backgroundColor: '#ffffff',
    color: '#000000',
    margin: '16px',
    borderRadius: '8px',
    boxShadow: tooltipShadow,
    zIndex: 1500,
    position: 'relative',
});

// Styled popper with our complicated arrow
export const StyledPopper = styled(Popper)({
    zIndex: 1500,
    '& .tooltip-arrow': {
        position: 'absolute',
        width: '1em',
        height: '0.71em',
        pointerEvents: 'none',
        zIndex: 1501,
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '0.71em',
            height: '0.71em',
            backgroundColor: '#ffffff',
            transform: 'rotate(45deg)',
        },
    },
    '& .tooltip-arrow-shadow': {
        position: 'absolute',
        width: '1em',
        height: '0.71em',
        pointerEvents: 'none',
        zIndex: 1499,
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '0.71em',
            height: '0.71em',
            backgroundColor: 'transparent',
            transform: 'rotate(45deg)',
            boxShadow: tooltipShadow,
        },
    },
    '&[data-popper-placement*="top"] .tooltip-arrow, &[data-popper-placement*="top"] .tooltip-arrow-shadow':
        {
            bottom: '10px',
        },
    '&[data-popper-placement*="bottom"] .tooltip-arrow, &[data-popper-placement*="bottom"] .tooltip-arrow-shadow':
        {
            top: '10px',
        },
    '&[data-popper-placement*="left"] .tooltip-arrow, &[data-popper-placement*="left"] .tooltip-arrow-shadow':
        {
            right: '10px',
        },
    '&[data-popper-placement*="right"] .tooltip-arrow, &[data-popper-placement*="right"] .tooltip-arrow-shadow':
        {
            left: '10px',
        },
});
